import Container from './ScheduleBatchModal.container';
import ScheduleBatchModal from './ScheduleBatchModal';

export default Container(ScheduleBatchModal);
